import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { countryCodes } from "../../../shared/countries/country-codes.const";
import { Bind } from "primeng/bind";
import { MultiSelect } from "primeng/multiselect";
import { FormsModule } from "@angular/forms";

export interface CountryChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-country-multiselect",
  templateUrl: "./country-multiselect.component.html",
  styleUrls: ["./country-multiselect.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, MultiSelect, FormsModule],
})
export class CountryMultiselectComponent implements OnInit {
  public readonly countryChange = output<string[]>();
  @Input() public countries;
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public countryList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildCountryList();
  }

  public onCountryChange(country: string[]) {
    this.countryChange.emit(country);
  }

  private buildCountryList() {
    Object.keys(countryCodes).map((key) => {
      this.countryList.push({
        label: countryCodes[key],
        value: key,
      });
    });
  }
}
